import { NgModule } from '@angular/core';

import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { SVGIconModule } from '@progress/kendo-angular-icons';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { PopoverModule } from '@progress/kendo-angular-tooltip';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FilterModule } from '@progress/kendo-angular-filter';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { PopupModule } from '@progress/kendo-angular-popup';
import { UploadModule } from '@progress/kendo-angular-upload';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { MenuModule } from '@progress/kendo-angular-menu';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';
@NgModule({
  imports: [
    LayoutModule,
    ButtonsModule,
    DropDownsModule,
    DialogsModule,
    InputsModule,
    LabelModule,
    IndicatorsModule,
    ListViewModule,
    SVGIconModule,
    TooltipModule,
    PopoverModule,
    GridModule,
    DateInputsModule,
    FilterModule,
    NavigationModule,
    PopupModule,
    UploadModule,
    FileSelectModule,
    MenuModule,
    PDFViewerModule,
  ],
  exports: [
    LayoutModule,
    ButtonsModule,
    DropDownsModule,
    DialogsModule,
    InputsModule,
    LabelModule,
    IndicatorsModule,
    ListViewModule,
    SVGIconModule,
    TooltipModule,
    PopoverModule,
    GridModule,
    DateInputsModule,
    FilterModule,
    NavigationModule,
    PopupModule,
    UploadModule,
    FileSelectModule,
    MenuModule,
    PDFViewerModule,
  ],
})
export class KendoModule {}
